import { Spin } from "antd";
import { DEFAULT_LOGIN_REDIRECT_SCREEN } from "common/constants";
import { resetStateAction } from "common/redux/resetStateAction";
import { useLazyFetchMeQuery, useSsoExchangeMutation } from "features/auth/authAPI";
import { updateTokens } from "features/auth/authSlice";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

function SsoCallbackPage() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ssoExchange] = useSsoExchangeMutation();
  const [fetchMe] = useLazyFetchMeQuery();
  const exchangeAttempted = useRef(false);

  useEffect(() => {
    if (exchangeAttempted.current) return;
    exchangeAttempted.current = true;

    const error = searchParams.get("error");
    if (error) {
      navigate("/login", { state: { ssoError: error } });
      return;
    }

    const code = searchParams.get("code");
    if (!code) {
      navigate("/login");
      return;
    }

    const handleExchange = async () => {
      dispatch(resetStateAction());

      const result = await ssoExchange({ code });
      if ("error" in result) {
        navigate("/login", { state: { ssoError: "SSO authentication failed." } });
        return;
      }

      await dispatch(updateTokens(result.data));

      const { data: me, error: meError } = await fetchMe();
      if (meError || !me) {
        navigate("/login", { state: { ssoError: "Failed to load user profile." } });
        return;
      }
      const defaultScreen = `/${me?.defaultLoginRedirectScreen || DEFAULT_LOGIN_REDIRECT_SCREEN}`;
      navigate(defaultScreen);
    };

    handleExchange();
  }, [searchParams, dispatch, navigate, ssoExchange, fetchMe]);

  return (
    <SpinnerContainer>
      <Spin size="large" tip="Completing sign-in..." />
    </SpinnerContainer>
  );
}

export default SsoCallbackPage;
